import React from 'react'
import { CustomTooltip } from 'src/designSystem'
import { penIcon } from 'src/designSystem/icons'
import moment from 'moment'
import type { DraftMessage } from './useDraftMessage'

type Props = {
  draftMessage: DraftMessage | null
}

const DraftMessageIndicator = ({ draftMessage }: Props) => {
  if (draftMessage) {
    const hoursUntilExpiration = moment(draftMessage.expiresAt).diff(moment(), 'hours')

    return (
      <CustomTooltip title={`Draft expires in ${hoursUntilExpiration} hours`} placement="right-end">
        <img src={penIcon} alt="draft message" />
      </CustomTooltip>
    )
  }

  return null
}

export default DraftMessageIndicator
